import { Context } from "@nuxt/types/app";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function (context: Context) {
  function colourDashboard(item: string): string {
    const itemUpperCaseFormatted = item.toLowerCase();
    switch (itemUpperCaseFormatted) {
      case "#ec1f27":
        return "simasnet";
      case "#213683":
        return "axa";
      case "#329945":
        return "equity-life";
      case "#ba181e":
        return "not-so-red";
      case "#e66868":
        return "salmon-pink";
      case "#ff7b00":
        return "sexy-mango";
      case "#00a55f":
        return "bluish-green";
      case "#8b2f97":
        return "violet";
      case "#3ba3fb":
        return "out-of-the-blue";
      case "#1e272e":
        return "black-and-white";
      case "#2167ae":
          return "zurich";   
      default:
        return "sexy-mango";
    }
  }

  return {
    colourDashboard,
  };
}
